import RoddakiApp from './RoddakiApp_uuid';
import AdminApp from './AdminApp';

function App() {
  if (window.location.pathname.startsWith('/admin')) {
    return <AdminApp />;
  }
  return <RoddakiApp />;
}

export default App;